import { render } from "./MagentoMigration.vue?vue&type=template&id=307bb2ed"
import script from "./MagentoMigration.vue?vue&type=script&lang=js"
export * from "./MagentoMigration.vue?vue&type=script&lang=js"

import "./MagentoMigration.vue?vue&type=style&index=0&id=307bb2ed&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__